import { useEffect, useState } from 'react';
import { useFieldActions } from '../../../../contexts/field-actions-context';
import { useConfig } from '../../../../contexts/config-context';
import { bulkSlotsSize, DataStatus, ErrorTypes } from '../../appointment-state';
import { calculateSelectedDate, getStartAndEndDate, getUserTimezone } from './utils';
import { Actions, Components } from '../../bi-types';
import { useAppointmentBi } from '../../utils/bi';
export default function useInitialAppointmentState(props) {
  var _loadInitialAppointme;
  const {
    initialData: loadInitialAppointmentDataResponse,
    onChange,
    value: selectedSlotFromProps
  } = props;
  const {
    isEditor,
    isComposer,
    instance
  } = useConfig();
  const serviceId = loadInitialAppointmentDataResponse == null || (_loadInitialAppointme = loadInitialAppointmentDataResponse.service) == null ? void 0 : _loadInitialAppointme.id;
  const {
    actions
  } = useFieldActions();
  const [appointmentState, setAppointmentState] = useState(null);
  const bi = useAppointmentBi(loadInitialAppointmentDataResponse == null ? void 0 : loadInitialAppointmentDataResponse.service);
  useEffect(() => {
    const initialAppointmentState = async () => {
      const timezone = getUserTimezone();
      const appointmentStateResult = {
        currentSlotBulkSize: bulkSlotsSize,
        timezone,
        dataStatus: DataStatus.LOADING
      };
      try {
        var _appointmentStateResu, _appointmentStateResu2, _appointmentStateResu3;
        const fetchAvailabilityDates = async range => {
          const {
            startDate,
            endDate
          } = getStartAndEndDate(range, timezone);
          return actions == null || actions.getAvailabilityDates == null ? void 0 : actions.getAvailabilityDates({
            serviceId: serviceId,
            fromDate: startDate,
            toDate: endDate,
            timeZone: timezone
          });
        };
        appointmentStateResult.availabilityDates = await fetchAvailabilityDates(2);
        if (!((_appointmentStateResu = appointmentStateResult.availabilityDates) != null && _appointmentStateResu.length)) {
          appointmentStateResult.availabilityDates = await fetchAvailabilityDates(6);
        }
        if (!((_appointmentStateResu2 = appointmentStateResult.availabilityDates) != null && _appointmentStateResu2.length)) {
          bi == null || bi.report({
            action: Actions.LOAD,
            component: Components.NO_AVAILABILITY_AT_ALL
          });
          setAppointmentState({
            dataStatus: DataStatus.ERROR,
            error: {
              type: ErrorTypes.NO_AVAILABILITY_DATES_FOUND,
              message: 'No availability dates found'
            }
          });
          return;
        }
        appointmentStateResult.selectedDate = calculateSelectedDate(appointmentStateResult.availabilityDates);
        if (appointmentStateResult.selectedDate) {
          appointmentStateResult.availabilitySlots = await (actions == null || actions.getAvailabilitySlots == null ? void 0 : actions.getAvailabilitySlots({
            serviceId: serviceId,
            timeZone: timezone,
            selectedDate: appointmentStateResult.selectedDate
          }));
        }
        bi == null || bi.report({
          action: Actions.LOAD,
          component: (_appointmentStateResu3 = appointmentStateResult.availabilityDates) != null && _appointmentStateResu3.length ? Components.FORM : Components.NO_AVAILABILITY_FOR_DATE
        });
        if (!(selectedSlotFromProps != null && selectedSlotFromProps.startDate)) {
          onChange(undefined);
        }
        setAppointmentState({
          ...appointmentStateResult,
          dataStatus: DataStatus.DONE
        });
      } catch (error) {
        console.error(error);
        setAppointmentState({
          dataStatus: DataStatus.ERROR,
          error: {
            type: ErrorTypes.GENERAL,
            message: 'An error occurred in initialAppointmentState'
          }
        });
      }
    };
    if (serviceId && !isEditor && !isComposer && actions != null && actions.getAvailabilitySlots && actions != null && actions.getAvailabilityDates && !!instance) {
      initialAppointmentState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditor, isComposer, serviceId, actions == null ? void 0 : actions.getAvailabilitySlots, actions == null ? void 0 : actions.getAvailabilityDates, instance]);
  return appointmentState;
}
//# sourceMappingURL=index.js.map